import ApiService from "../base/api_service";

export const getLabaRugi = async (accessToken, params) => {
    try {

        const response = await ApiService.get(`/laba-rugi`, {
            params: params,
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })

        return response

    } catch (error) {
        return error.response;
    }
}

export const exportLabaRugi = async (accessToken, params) => {
    try {
        const response = await ApiService.get(`/laba-rugi/export`, {
            params: params,
            responseType: 'blob',
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })
        return response
    } catch (error) {
        return error.response;
    }
} 